'use client';

import type {
  ProfileFieldUpdateRequest,
  ProfileUpdateRequest,
  UserProfile,
} from '@/types/profile-types';
import ApiService, { type ApiResponse } from './api-services';

class ProfileServices extends ApiService {
  constructor() {
    super('/users');
  }

  getUserProfile(): ApiResponse<UserProfile> {
    return this.getData('/profile');
  }

  updateUserProfile(
    updateData: ProfileUpdateRequest
  ): ApiResponse<UserProfile> {
    return this.postData('/profile', updateData);
  }

  updateUserProfileField(
    fieldData: ProfileFieldUpdateRequest
  ): ApiResponse<UserProfile> {
    return this.patchData('/profile/field', fieldData);
  }
}

export default new ProfileServices();
